import React from 'react'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'
import FormatUtils from '@front/squirtle/utils/format'

const Row = ({ row }) => <>
  <TableCell size='small'><TextCell value={row?.list_client_id} /></TableCell>

  <TableCell size='small'><TextCell value={FormatUtils?.formatDateBackToFront(row?.createdAt)} /></TableCell>
</>

export default React.memo(Row)
